/* eslint-disable jsx-a11y/no-static-element-interactions */
import { ChevronDown, ChevronUp } from 'lucide-react';
import React, { useEffect, useState } from 'react';

const InfoToggle = ({
  children,
  title = '',
  openIcon = <ChevronDown size={20} className='tw-mt-[1px]' />,
  closeIcon = <ChevronUp size={20} className='tw-mt-[1px]' />,
  defaultOpen = false,
  onOpen = () => {},
  onClose = () => {},
  duration = 300,
  showBorder = true,
  borderStyles = '',
  bgColor = '',
  styles = '',
  isOpen = false,
  disabled = false,
}) => {
  const [showContent, setShowContent] = useState(defaultOpen);

  const toggleContent = () => {
    setShowContent((prev) => {
      if (prev) onClose();
      else onOpen();
      return !prev;
    });
  };

  useEffect(() => {
    setShowContent(isOpen);
  }, [isOpen]);

  return (
    <div
      className={`tw-flex tw-flex-col tw-font-medium tw-text-[1.3rem] tw-rounded-lg ${styles} ${
        showBorder ? borderStyles : ''
      } ${bgColor} ${showContent ? '' : 'tw-cursor-pointer'}`}
      onClick={showContent ? () => {} : toggleContent}
    >
      <div
        className='tw-flex tw-items-center tw-gap-1 tw-cursor-pointer tw-justify-between tw-leading-none tw-text-[1.3rem] tw-w-full'
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled) toggleContent();
        }}
      >
        {title} {showContent ? closeIcon : openIcon}
      </div>

      <div
        className={`tw-grid tw-p-0 tw-m-0 tw-transition-all tw-ease-in-out ${
          showContent
            ? 'tw-opacity-100 tw-visible tw-pointer-events-auto'
            : 'tw-opacity-0 tw-invisible tw-pointer-events-none'
        }`}
        style={{
          gridTemplateRows: showContent ? '1fr' : '0fr',
          transitionDuration: `${duration}ms`,
        }}
      >
        <div className='tw-min-h-0 tw-overflow-hidden'>{children}</div>
      </div>
    </div>
  );
};

export default InfoToggle;
